<template>
    <transition-group id="gritter-notice-wrapper" class="gritter-main-wrapper top-right" name="notification" tag="div">
        <be-notification class="notification-item d-print-none" v-for="item in notifications" :key="item.id" v-bind="item"/>
    </transition-group>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState('notifications', ['notifications']),
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .gritter-main-wrapper {
        .notification-item {
            transition: all 1s;
        }
        .notification-enter {
            opacity: 0;
            transform: translateY(30px);
        }

        .notification-leave-to {
            opacity: 0;
            transform: translateY(-120%);
        }

        .notification-leave-active {
            position: absolute;
        }
    }
</style>
